let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6BkMx")).then(() => parcelRequire('74VfG'));